import axios from 'axios';
import { wrapAxiosInstance } from '../cache/modules/axiosFactory';
import { setupAuthInterceptor, retryWithBackoff } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.management_api.ingredient_purchases;

const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' }
}));

const cachedApi = wrapAxiosInstance(api, {
  namespace: 'management_api',
  group: 'ingredient_purchases',
  defaultTtl: '2m',
  hashLargeSegments: true,
  emitMeta: true,
});


export const getAllIngredientPurchasesByLocalIdAndDateRange = async (
  localId: number,
  startDate: string,
  endDate: string
) => {
  return await retryWithBackoff(() =>
    api.post(`/GetAllIngredientPurchasesByLocalId/${localId}`, {
      start_date: startDate,
      end_date: endDate,
    })
  );
};

export interface CreatePurchasePayload {
  local_id: number;
  invoice_id?: number | null;
  ingredient_id?: number | null;
  ingredient_name?: string | null;
  provider_id?: number | null;
  quantity: number;
  total_neto: number;
  unidad_medida_id: number;
  brand_id?: number | null;
  update_stock?: boolean | null;
  storage_unit_id?: number | null;
  user_id?: number | null;
  purchase_date?: string | null;
  tax_type?: string | null;
  tax_amount?: number | null;
  total_with_tax?: number | null;
  expense_category_id?: number | null;
  notes?: string | null;
}

export const createIngredientPurchaseRecord = async (data: CreatePurchasePayload) => {
  const res = await retryWithBackoff(() =>
    api.post('/CreateIngredientPurchaseRecord', data)
  );
  await cachedApi.clear();
  return res;
};

export const createBatchIngredientPurchaseRecords = async (
  localId: number,
  userId: number | null,
  items: Omit<CreatePurchasePayload, 'local_id' | 'user_id'>[]
) => {
  const res = await retryWithBackoff(() =>
    api.post('/CreateBatchIngredientPurchaseRecords', {
      local_id: localId,
      user_id: userId,
      items,
    })
  );
  await cachedApi.clear();
  return res;
};

export const updateIngredientPurchaseRecord = async (
  purchaseId: number,
  data: Omit<CreatePurchasePayload, 'local_id'> & { local_id: number }
) => {
  const res = await retryWithBackoff(() =>
    api.put(`/UpdateIngredientPurchaseRecord/${purchaseId}`, data)
  );
  await cachedApi.clear();
  return res;
};

export const deleteIngredientPurchaseRecord = async (purchaseId: number) => {
  const res = await retryWithBackoff(() =>
    api.delete(`/DeleteIngredientPurchaseRecord/${purchaseId}`)
  );
  await cachedApi.clear();
  return res;
};